// Whether the floating agent bubble should exist at all for this person, workspace and page.
export function showAgentBubble(opts: { canRun: boolean; canRead: boolean; moduleEnabled: boolean; pathname: string }): boolean {
  if (!opts.canRun || !opts.canRead || !opts.moduleEnabled) return false;
  // The Agents page already is this panel, and /portal never mounts AppShell (belt and braces).
  return !(opts.pathname === "/agents" || opts.pathname.startsWith("/agents/") || opts.pathname.startsWith("/portal"));
}
